// extracted by mini-css-extract-plugin
export default {"page":"notFound_page__U8rxA","body":"notFound_body__lCdGW","img":"notFound_img__gAcDh"};